export enum FlowCloneReason {
  Unknown = 'unknown_reason',
  TransactionEdit = 'transaction_edit',
  ChangePaymentOnFail = 'change_payment_on_fail',
  ChangeNonFinishedPayment = 'change_non_finished_payment'
}
